import { render, staticRenderFns } from "./NodeAllocationBillingBreakdown.vue?vue&type=template&id=c479d6ce&scoped=true&"
import script from "./NodeAllocationBillingBreakdown.vue?vue&type=script&lang=js&"
export * from "./NodeAllocationBillingBreakdown.vue?vue&type=script&lang=js&"
import style0 from "./NodeAllocationBillingBreakdown.vue?vue&type=style&index=0&id=c479d6ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c479d6ce",
  null
  
)

export default component.exports